import { Link } from 'react-router-dom';
import { blogArticles } from '@/mocks/categories';

export default function BlogGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <h2 className="text-foreground-950 font-heading text-3xl md:text-5xl font-bold leading-[1.2]">
              Spreadsheet<br />Resources
            </h2>
          </div>
          <p className="text-foreground-500 text-sm max-w-xs font-body">
            In-depth guides, comparisons, and tutorials to help you master the ACBuySpreadsheet system.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 md:gap-5">
          {blogArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1 bg-background-100 hover:bg-background-200/70"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block text-xs font-semibold px-2.5 py-1 rounded-full mb-3 font-label bg-secondary-100 text-secondary-800">
                  {article.label}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold leading-snug mb-2 text-foreground-950 group-hover:text-foreground-800 transition-colors">
                  {article.title}
                </h3>
                <p className="text-xs md:text-sm leading-relaxed mb-4 font-body text-foreground-500 line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <span className="text-xs font-label text-foreground-400">
                    {article.date}
                  </span>
                  <span className="text-sm font-semibold font-label flex items-center gap-1 text-primary-600">
                    Read More
                    <i className="ri-arrow-right-line"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}